module.exports = __webpack_public_path__ + "img/member-pic4.07ee7cdd.png";